export default __webpack_public_path__ + "static/media/RINGS -white.27eef63b.png";